"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.isNonEmptyArray=function(r){return Array.isArray(r)&&r.length>0};
//# sourceMappingURL=arrays.js.map
